<template>
  <div class="activity-rate-fields">
    <h5 class="pcs-form-section">{{ _('Prices') }}</h5>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label>{{ _('Price per booking') }}</label>
          <div class="input-group">
            <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" v-model="form.price" :placeholder="placeholder('price')" />
            <span class="input-group-addon">{{ currency }}</span>
          </div>
          <p class="help-block" v-if="help('price')">{{ help('price') }}</p>
        </div>
      </div>
      <div class="col-sm-6" v-for="tier in tiers" :key="'ft-' + tier.id">
        <div class="form-group">
          <label>{{ tier.name }}</label>
          <div class="input-group">
            <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" v-model="form.tiers[tier.id]" :placeholder="placeholder('tier:' + tier.id)" />
            <span class="input-group-addon">{{ currency }}</span>
          </div>
          <p class="help-block" v-if="help('tier:' + tier.id)">{{ help('tier:' + tier.id) }}</p>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label>{{ _('Base price includes') }}</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" v-model="form.includes" :placeholder="placeholder('includes')" />
            <span class="input-group-addon">{{ _('participants') }}</span>
          </div>
          <p class="help-block" v-if="help('includes')">{{ help('includes') }}</p>
        </div>
      </div>
    </div>
    <p class="help-block" v-if="tiers.length">{{ _('Ticket type prices replace each other: a ticket type left empty is free.') }}</p>
    <h5 class="pcs-form-section">{{ _('Participants') }}</h5>
    <div class="row">
      <div class="col-sm-6" v-for="field in ['minparticipants', 'maxparticipants']" :key="'fp-' + field">
        <div class="form-group">
          <label>{{ field === 'minparticipants' ? _('Minimum participants') : _('Maximum participants') }}</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" v-model="form[field]" :placeholder="placeholder(field)" />
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" :title="_('No limit')" v-on:click="form[field] = '0'">{{ _('Clear') }}</button>
            </span>
          </div>
          <p class="help-block" v-if="help(field)">{{ help(field) }}</p>
        </div>
      </div>
    </div>
    <h5 class="pcs-form-section">{{ _('Availability') }}</h5>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label>{{ _('For sale') }}</label>
          <select class="form-control" v-model="form.closed">
            <option value="">{{ closedEmptyLabel }}</option>
            <option value="0">{{ _('On sale') }}</option>
            <option value="1">{{ _('Closed') }}</option>
          </select>
          <p class="help-block" v-if="help('closed')">{{ help('closed') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formats from '~/lib/formats'

// The price fields of the activity calendar's dialogs (the date dialog and the weekly dialog):
// form { price, tiers { id: price }, includes, minparticipants, maxparticipants, closed ('' / '0' /
// '1') } is edited in place. placeholder(key) and help(key) take 'price', 'tier:<id>', 'includes',
// 'minparticipants', 'maxparticipants' or 'closed'.
export default {
  mixins: [formats],
  props: {
    form: { type: Object, required: true },
    tiers: { type: Array, default: () => [] },
    currency: { type: String, default: '' },
    placeholder: { type: Function, default: () => '' },
    help: { type: Function, default: () => '' },
    closedEmptyLabel: { type: String, default: '' }
  }
}
</script>
